import { Sidebar } from "../../../../components/SharedComponents/sharedComponents.index";

export const usesSidebarLayout = () => true;

export const MenuLayout = ({
  actions,
  ctx,
  uiState,
  tenantOverride,
}) => {
  return (
    <Sidebar
      actions={actions}
      ctx={ctx}
      uiState={uiState}
      tenantOverride={tenantOverride}
    />
  );
};